import { render, staticRenderFns } from "./CommentLabelButton.vue?vue&type=template&id=d631eb7e&"
import script from "./CommentLabelButton.vue?vue&type=script&lang=js&"
export * from "./CommentLabelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports